import React, {useContext, useEffect, useState} from 'react';
import {Button, Card, Dimmer, Header, Loader, Menu, Segment} from 'semantic-ui-react'
import {fetchCourseSections} from "../../../../../redux/actions";
import {Context} from './index'
import {SectionForm} from "./SectionForm";
import {TopicForm} from "./TopicForm";

const Topic = ({topic, handleShowTopicForm}) => {
    return (
        <Menu.Item onClick={() => handleShowTopicForm(true, topic)}>{topic.title}</Menu.Item>
    )
}

export const Topics = () => {
    const ctx = useContext(Context);

    const [loading, setLoading] = useState(false);
    const [topics, setTopics] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [showTopicForm, setShowTopicForm] = useState({
        open: false,
        item: {},
    });

    const course_id = ctx.course_id;
    const section_id = ctx.section_id;

    function handleShowTopicForm(open, item = {}) {
        setShowTopicForm({
            open,
            item,
        })
    }

    async function getTopics(video = false) {
        if(!video){
            setLoading(true);
            setShowForm(false);
            handleShowTopicForm(false);
        }

        try {
            // get data
            const res = await fetchCourseSections({course_id, parent_id: section_id});
            // set data
            setTopics(res.data);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        if (!section_id) {
            return;
        }
        // noinspection JSIgnoredPromiseFromCall
        getTopics();

    }, [course_id, section_id])

    const message = (section_id && !loading) ? 'Nenhuma aula encontrada, crie a primeira!' : 'Selecione um Módulo';

    return (
        <Card fluid>
            <SectionForm
                show={showForm}
                item={{course_id, section_id}}
                onCancel={() => setShowForm(false)}
                onSuccess={getTopics}
            />
            <TopicForm
                show={showTopicForm.open}
                item={showTopicForm.item}
                onCancel={() => handleShowTopicForm(false)}
                onSuccess={(video) => getTopics(video)}
            />
            <Dimmer active={loading}>
                <Loader/>
            </Dimmer>
            <Card.Content>
                <Card.Header>Aulas ({topics.length})</Card.Header>
            </Card.Content>
            <Card.Content>
                {
                    (section_id && topics.length > 0) ? <Menu fluid secondary vertical>
                        {topics.map((topic) => {
                            return <Topic
                                key={`topic-${topic.id}`}
                                topic={topic}
                                handleShowTopicForm={handleShowTopicForm}
                            />;
                        })}
                    </Menu> : (<Segment basic textAlign={"center"}>
                        <Header size={"medium"}>
                            {message}
                        </Header>
                    </Segment>)
                }
                {
                    (section_id && !loading) ? <Menu.Item>
                        <Button primary fluid onClick={() => setShowForm(true)}>Criar Aula</Button>
                    </Menu.Item> : ''
                }
            </Card.Content>
        </Card>
    )
}